/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

"use client";

import { CosmosComponentContextProps, getHero, ResearchCardsContainer } from "@cosmos/components";
import { PageResearchFragment } from "@cosmos/hygraph-schema";
import { useAuth } from "@cosmos/next-hooks";

import { TemplateProviders } from "../templates/TemplateProviders";

interface CosmosPageProps {
	pageData?: PageResearchFragment;
	componentContext: CosmosComponentContextProps;
}

export const CosmosPageResearch = ({ pageData, componentContext }: CosmosPageProps): React.JSX.Element => {
	useAuth(!componentContext.enableAuth);

	return (
		<TemplateProviders componentContext={componentContext}>
			{getHero(pageData?.hero)}
			<ResearchCardsContainer items={pageData?.researchCards} config={pageData?.researchCardsSectionConfig} />
		</TemplateProviders>
	);
};
